import React from "react";
import { ActionType, useProductMedia, useProductMediaDispatch } from "./FilesContext";
import FileInfo from "./FileInfo";
import AddVideoButton from "./AddVideoButton";
import AddImageButton from "./AddImageButton";
import Sortable from "@admin/components/Sortable";
import { ProductMediaModel } from "@admin/domain/products/models/edit/ProductAttributesModel";
import { useSortableIsDisabled } from "@admin/components/Sortable/SortableContext";
import SortingButton from "@admin/components/Sortable/SortingButton";

export default function FilesList() {
    const productMedia = useProductMedia();
    const dispatch = useProductMediaDispatch();

    return (
        <>
            <Sortable
                list={productMedia}
                setList={(newMedia: ProductMediaModel[]) => {
                    if (newMedia[0]?.file?.mime?.startsWith(`video`)) {
                        alert(`Видео не может быть указано в качестве основного`);
                        return;
                    }

                    dispatch({ type: ActionType.Sort, newMedia });
                }}
                disabled={useSortableIsDisabled()}
            >
                {productMedia.map(({ id, file, mobile_app_file }, mediaIndex) => (
                    <div key={id} className="rounded border p-10 mb-5 position-relative">
                        <SortingButton top={1} right={1} />
                        <FileInfo file={file} mediaId={id} mediaIndex={mediaIndex} />
                        {!mobile_app_file &&
                            (file.preview_file ? <AddVideoButton mediaId={id} /> : <AddImageButton mediaId={id} />)}
                        {mobile_app_file && (
                            <FileInfo file={mobile_app_file} mediaId={id} mediaIndex={mediaIndex} forMobileApp />
                        )}
                    </div>
                ))}
            </Sortable>
        </>
    );
}
